module.exports = {
  purge: [
    './src/**/*.vue',
    './src/**/*.js',
  ],
  theme: {
    extend: {
      colors: {
        primary: '#0083B5',
        secondary: '#476071',
        accent: '#2C3842',
        theme_green: '#2FB5B2',
        theme_orange: '#FB6937',
        action: {
          default: '#dd6a20',
          dark: '#d26b33',
        },
        secondary_light: '#F8FAFC',
        gray_1: "#EFEFEF",
        gray_2: "#E4EAEF"
        
      },
      fontSize: {
        '2r': '2rem',
        }
    },
  },
  variants: {
    backgroundColor: ['responsive','hover', 'focus', 'odd'],
  },
  plugins: [],
}
